﻿export class TypeProcessEnum {

    static #_instance: TypeProcessEnum

    public static get Instance() {
        this.#_instance ??= new TypeProcessEnum();
        return this.#_instance;
    }

    public get Html() {
        return 1
    }

    public get Mail() {
        return 0
    }

    public get Pdf() {
        return 2
    }

    public get PdfAndMail() {
        return 3
    }

    public GetLibelle = (value: number) => {
        switch (value) {
            case 0:
                return "Mail";
            case 1:
                return "Html";
            case 2:
                return "Pdf";
            case 3:
                return "PdfAndMail";
        }
    }

    public GetByLibelle = (value: string) => {
        switch (value) {
            case "Mail":
                return this.Mail;
            case "Html":
                return this.Html;
            case "Pdf":
                return this.Pdf;
            case "PdfAndMail":
                return this.PdfAndMail;
            default:
                throw new Error("Type de process inconnu");

        }
    }

    public get GetListeLibelle() {
        return [
            {
                value: 0,
                text: "Mail"
            },
            {
                value: 1,
                text: "Html"
            },
            {
                value: 2,
                text: "Pdf"
            }, {
                value: 3,
                text: "PdfAndMail"
            },
        ]
    }
}